import React, {Fragment} from 'react';
import { Button } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import XLSX from 'xlsx' 


const customTotal = (from, to, size) => (
  <span className="react-bootstrap-table-pagination-total">
    Mostrando registros del  { from } al { to } de { size } registros
  </span>
);

const columns = [
  {
    dataField: 'Numero_Folio_Real',
    text: 'Folio',
    sort: true,
    filter: textFilter(),
    style: {whiteSpace: 'normal', verticalAlign: 'middle'},
    headerStyle: () => {
        return { width: "15%" };
    },
  },
  {
    dataField: 'Nombre_Sociedad',
    text: 'Nombre de la Sociedad',
    sort: true,
    filter: textFilter(),
    style: {whiteSpace: 'normal', verticalAlign: 'middle'},
   },
    {
      dataField: 'Modulo',
      text: 'Tipo de registro',
      sort: true,
      filter: textFilter(),
      style: {whiteSpace: 'normal', verticalAlign: 'middle'},
    },
    {
      dataField: 'Status',
      text: 'Condición',
      sort: true,
      filter: textFilter(),
      style: {whiteSpace: 'normal', verticalAlign: 'middle'},
    },
    {
      dataField: 'Fecha_Constitucion',
      text: 'Fecha de Inscripción',
      sort: true,
      filter: textFilter(),
      style: {whiteSpace: 'normal', verticalAlign: 'middle'},
      headerStyle: () => {
          return { width: "7%" };
      },
    },
    {
      dataField: 'Fecha_Asiento_Suspension',
      text: 'Fecha de Suspensión',
      sort: true,
      filter: textFilter(),
      style: {whiteSpace: 'normal', verticalAlign: 'middle'},
      headerStyle: () => {
          return { width: "7%" };
      },
    },

  ]

function Fincamadre({fincasMadres}) {  


      const exportFile = () => {
        let fincas = [["Folio","Nombre de la Sociedad","Tipo de registro","Status / Condición","Fecha de Inscripción","Fecha de Suspensión"]]
        fincasMadres.forEach((finca) => {
          let fincasArray = [finca.Numero_Folio_Real,finca.Nombre_Sociedad,finca.Modulo,finca.Status,finca.Fecha_Constitucion,finca.Fecha_Asiento_Suspension]
          fincas.push(fincasArray)
        })
        
        const wb = XLSX.utils.book_new()
        const wsAll = XLSX.utils.aoa_to_sheet(fincas)
            XLSX.utils.book_append_sheet(wb, wsAll, "All Users")
            XLSX.writeFile(wb, "FoliosAnotacionSuspension.xlsx")
      }


      const options = {
          paginationSize: 4,
          pageStartIndex: 0,
          firstPageText: 'Primero',
          prePageText: 'Anterior',
          nextPageText: 'Siguiente',
          lastPageText: 'Ultimo',
          nextPageTitle: 'Primera pagina',
          prePageTitle: 'Pagina anterior',
          firstPageTitle: 'Pagina siguiente',
          lastPageTitle: 'Ultimo pagina',
          showTotal: true,
          paginationTotalRenderer: customTotal,
          sizePerPageList: [{
            text: '5', value: 5
          }, {
            text: '10', value: 10
          }, {
            text: 'Mostar todos', value: fincasMadres.length
          }] 
      };


     
     if(fincasMadres.length === 0) return null;

    

     return (
         <Fragment>
             <Button color="success" onClick={exportFile}>Exportar a Excel</Button>
            <BootstrapTable keyField='id' data={ fincasMadres } columns={ columns } filter={ filterFactory() } pagination={ paginationFactory(options) } />
         </Fragment>
     );

}


export default Fincamadre;